import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';
import ErrorMessage from './ErrorMessage';
import './UI.css';

/**
 * Unified loading / error / empty handling for API-driven views.
 */
const PageStatus = ({
  isLoading = false,
  loadingText,
  error = null,
  onRetry,
  retryText,
  isEmpty = false,
  emptyIcon = 'package',
  emptyTitle,
  emptyDescription = '',
  emptyActionText = '',
  emptyActionLink = '/',
  onEmptyAction = null,
  variant = 'section',
  children,
}) => {
  const fullPage = variant === 'fullPage';

  if (isLoading) {
    return (
      <LoadingSpinner
        text={loadingText}
        fullPage={fullPage}
        className={variant === 'inline' ? '' : undefined}
      />
    );
  }

  if (error) {
    const message =
      typeof error === 'string'
        ? error
        : error?.message || 'Something went wrong. Please try again.';
    return (
      <ErrorMessage
        message={message}
        onRetry={onRetry}
        retryText={retryText}
        variant={variant}
      />
    );
  }

  if (isEmpty) {
    return (
      <EmptyState
        icon={emptyIcon}
        title={emptyTitle}
        description={emptyDescription}
        actionText={emptyActionText}
        actionLink={emptyActionLink}
        onAction={onEmptyAction}
        variant={variant}
      />
    );
  }

  return children ?? null;
};

export default PageStatus;
